<!--
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd. All rights reserved.
This file contains Protected Intellectual Property owned by Kaleida Ltd and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (explicitly not developed by Kaleida), whether or not such application forms part of the Platform.
For the avoidance of doubt, the inclusion of any application within the Platform does not of itself grant any right to use Protected Intellectual Property in that application unless that application was developed by Kaleida.
-->
<!-- IP-NOTICE: PROTECTED -->
<div [formGroup]="dataForm" class="aside-content aside-width-7">
  <div class="aside-header flex-layout-row flex-layout-align-space-between-center">
    <h3>Create Defect</h3>
    <div class='flex-layout-gap-10px'>
      <button mat-raised-button (click)="save()" color="primary">Create</button>
      <button mat-raised-button (click)="cancel()">Cancel</button>
    </div>
  </div>
  <div>
    <div>
      <mat-form-field>
        <mat-label>Description</mat-label><input formControlName="description" matInput />
      <mat-error *ngIf="description.touched && description.errors?.required"> Description is required </mat-error><mat-error *ngIf="description.touched && description.errors?.maxlength"> Description must be no more than 200 characters </mat-error></mat-form-field>


    </div>

    <div>
      <mat-form-field>
        <mat-label>Feature</mat-label><input matInput [formControl]="softwareFeatureId" [matAutocomplete]="autoFeature" />
        <mat-autocomplete #autoFeature="matAutocomplete" [displayWith]="displaySelectedItem">
          <mat-option *ngFor="let lookup of softwareFeatureIdLookupData" [value]="lookup"> {{ lookup.text }} </mat-option>
        </mat-autocomplete>
      <mat-error *ngIf="softwareFeatureId.touched && softwareFeatureId.errors?.required"> Feature is required </mat-error></mat-form-field>


    </div>

    <div>
      <label for="details" class="display-label">Details</label>
      <editor formControlName="details" apiKey="ey608wvcvuc71ndbwojkfvuttigst7o428fhlknq9bwbrog6" [init]="tinyMceSettings"></editor>
      <mat-error *ngIf="details.touched && details.errors?.required"> Details is required </mat-error>
    </div>

    <div>
      <label for="reproductionSteps" class="display-label">Reproduction Steps</label>
      <editor formControlName="reproductionSteps" apiKey="ey608wvcvuc71ndbwojkfvuttigst7o428fhlknq9bwbrog6" [init]="tinyMceSettings"></editor>
    </div>

    <div>
      <label for="attachments" class="display-label">Attachments</label>
      <file-uploader entityType="doc" [endpointUrl]="uploadEndpoint" fileType="2" [hideApplyAndCancelButtons]="true" (onCompleteAllEvent)="fileUploadComplete()" [compress]="false" [allowedMimeType]="allowedTypes" maxFilesToUpload="1" [baseApiUrlOverride]="baseEndpointOverride" [includeAuthenticationHeader]="false">
      </file-uploader>
    </div>
  </div>
</div>
